module.exports = __webpack_public_path__ + "img/flow_1.7818b260.png";